module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductDetailImages":{"showMorePictures":"Načíst další fotky ({count})"}},"en":{"ProductDetailImages":{"showMorePictures":"Load more images ({count})"}}}')
  delete Component.options._Ctor
}
